export const environment = {
  production: true,
  sentryRelease: 'will-be-injected-by-ci'
};
